import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "../service";

export const updateUserAction = createAsyncThunk(
  "admin/updateUserAction",
  async (addUserData, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_TEST_API}/users`,
        addUserData,
        { headers: myHeaders() }
      );
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.clear();
        window.location.assign("/");
      }
      if (error) {
        return rejectWithValue(error.message);
      }
    }
  }
);
